var styles = {"maintenancePage":"bc-maintenance-page__maintenancePage","img":"bc-maintenance-page__img"};

export { styles as default };
